<app-sub-menu *ngIf="checklist else loadingSubmenu" [subMenus]="subMenus"></app-sub-menu>
<ng-template #loadingSubmenu>
  <div class="row">
    <div class="submenu">
      <div class="skeleton p-1 rounded submenu__item d-flex align-items-center" style="height: 40px;"></div>
    </div>
  </div>
</ng-template>
<div class="container-fluid bg-box configuracion">
  <h3 *ngIf="checklist else loadingChecklist">{{ checklist.Nombre }} ({{ checklist.Ponderacion }}%)</h3>
  <ng-template #loadingChecklist>
    <h3>
      <div class="skeleton p-2 ml-1 rounded" style="width: 3rem"></div>
    </h3>
  </ng-template>
  <hr />
  <div *ngIf="bloques else loadingBloques">
    <div class="card mt-2" *ngFor="let bloque of bloques">
      <div class="card-body">
        <h6 class="card-title">
          Bloque: {{ bloque.Nombre }} ({{ bloque.Ponderacion }}%)
        </h6>
        <div class="card mt-2" *ngFor="let rubro of bloque.Rubros">
          <div class="card-body">
            <h6 class="card-title">
              Rubro: {{ rubro.Nombre }} ({{ rubro.Ponderacion }}%)
            </h6>
            <div class="card mt-2" *ngFor="let pregunta of rubro.Preguntas">
              <div class="card-body">
                <h6 class="card-title">
                  {{ pregunta.Descripcion }} ({{ pregunta.Ponderacion }}%)
                </h6>
                <div class="row" *ngFor="let respuesta of pregunta.Respuestas">
                  <div class="col-md-3">{{ respuesta.Label }}</div>
                  <div *ngIf="respuesta.Ponderacion == null" class="col-md-2">
                    -NA-
                  </div>
                  <div *ngIf="respuesta.Ponderacion != null" class="col-md-2">
                    ({{ respuesta.Ponderacion }}%)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loadingBloques>
    <div class="skeleton p-2 rounded card mt-2" style="height: 500px;"></div>
  </ng-template>
</div>
